<template>
  <Form
    :action-type="actionType"
    :subtitle="subtitle"
    :disabled="wasDisabled"
    :fallback-link="fallbackLink"
    :form-body="form"
    :show-preloader="isLoadingNow"
    @on-submit="submit"
    @on-edit="setEditMode(true)"
    @on-cancel="setEditMode(false)"
  >
    <template slot="top-panel-buttons">
      <div v-if="actionType !== 'add'">
        <button
          :disabled="wasDisabled"
          class="btn btn-danger"
          @click="submit('delete')"
        >
          <i class="fa fa-trash" />
          Удалить
        </button>
      </div>
    </template>
    <template slot="fields">
      <div v-if="actionType !== 'add'" class="row form-group">
        <div class="col-lg-12">
          <div class="col-lg-6">
            <span><b>Тип:</b> {{ type.toLowerCase() }}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div
            v-for="(value, key, index) in labels"
            :key="index"
            class="col-lg-6 form-group"
          >
            <fieldset>
              <label>
                {{ value }}
                <span
                  v-if="isRequiredField(validationSchema[key])"
                  class="field__label_required"
                  >*</span
                >
              </label>
              <input
                class="form-control"
                :name="key"
                :maxlength="maxLength[key]"
                placeholder="Отсутствует"
                :disabled="actionType === 'read'"
                v-model.trim="form[key]"
              />
            </fieldset>
          </div>
        </div>
      </div>
      <UsersList
        class="form-group"
        label="Удостоенные пользователи"
        :form="form"
        :inputs-were-disabled="!!(actionType === 'read')"
      />
      <GeneratedIcon :form="form" :with-actions="actionType !== 'read'" />
    </template>
  </Form>
</template>

<script>
import { validationMixin } from "vuelidate";
import schemas from "@/user/validation-schemas";

import Form from "@/_shared/widgets/Form";
import GeneratedIcon from "@/user/widgets/achievements/GeneratedIcon";
import UsersList from "@/user/widgets/users/UsersList";

import { useForm, useNotification, useFieldTranslator } from "@/_shared/mixins";
import { formsFields } from "@/user/constants";

import { objectHelper } from "@/_shared/utils";
import { achievementsService } from '@/user/api-services';
const { createCopy, createFromKeys } = objectHelper;
export default {
  mixins: [
    validationMixin,
    useForm,
    useNotification,
    useFieldTranslator,
  ],
  components: {
    Form,
    GeneratedIcon,
    UsersList,
  },
  data() {
    return {
      isDelitingNow: false,
      fallbackLink: "/achievements",
      entityName: {
        readonly: "Достижение",
        modify: "достижения",
      },
      form: createFromKeys(formsFields.achievement.labels),
    };
  },
  validations() {
    return {
      form: this.validationSchema,
    };
  },
  async created() {
    const addingFields = createCopy(this.form);
    const callback = achievementsService.get;
    await this.setFormFields(addingFields, callback).then(() => {
      if (this.actionType === 'add') {
        this.form.users = [];
        this.form.icon_background = '#0088cc';
        this.form.icon_name = 'medal';
      }
    });
  },
  computed: {
    type() {
      if (this.actionType === 'add') {
        return false;
      }
      return this.getTranslatedAchievementType(this.form.type);
    },
    labels() {
      const {
        name,
        description,
        receipt_condition,
      } = formsFields.achievement.labels;
      return { name, description, receipt_condition };
    },
    maxLength() {
      return formsFields.achievement.maxLength;
    },
    validationSchema() {
      return schemas.achievement;
    },
  },
  methods: {
    async submit(manualAction = null) {
      const action = manualAction || this.actionType;
      const callback = async() => {
        return await achievementsService[action](this.form);
      };
      const withValidation = (action !== 'delete');
      await this.sendForm(callback, withValidation);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/user/pages/AchievementPage.vue